import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'

export class GetBrandDetailApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'brand/listBrandDetailModules',
      requesterInfo,
    })
  }

  public async getBrand(request: number): Promise<any[]> {
    this.props.url = `${this.props.url}/${request}`
    return await this.getAsync<any[]>()
  }
}
